import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Organized%20fashion%20product%20display%20with%20neatly%20arranged%20sneakers%20hoodies%20and%20bags%20on%20warm%20terracotta%20toned%20wooden%20surface%2C%20creative%20order%20concept%20with%20colorful%20sticky%20notes%20labeling%20categories%2C%20bright%20natural%20daylight%20streaming%20through%20large%20windows%2C%20clean%20editorial%20product%20photography%20with%20intentional%20composition%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20modern%20retail%20concept%20display%20with%20organized%20clothing%20and%20accessories%20showcasing%20variety%20and%20abundance&width=1600&height=900&seq=vigorbuy-hero-02&orientation=landscape"
          alt="Vigorbuy Spreadsheet product research and shopping guides - fashion products arranged on warm linen background"
          title="Vigorbuy Spreadsheet - Organized Product Research Resource"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <div className="w-1.5 h-1.5 rounded-full bg-accent-400"></div>
            <span className="text-xs font-medium text-background-50 tracking-wide uppercase">Updated 2026 Resources</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
            Vigorbuy Spreadsheet
          </h1>
          <p className="text-lg md:text-xl text-background-50/80 max-w-2xl mx-auto mb-4 font-light leading-relaxed">
            The Ultimate Resource For Product Research &amp; Shopping Guides
          </p>
          <p className="text-sm md:text-base text-background-50/60 max-w-xl mx-auto mb-8 leading-relaxed">
            Find organized Vigorbuy Spreadsheet resources, product categories, comparison guides, and updated shopping information in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              <i className="ri-shopping-cart-line mr-2"></i>
              Buy It Now
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-base hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line mr-2"></i>
              Vigorbuy Spreadsheet
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-background-50/70">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Updated Resources
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Beginner Friendly
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Product Research Guides
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i>
              Safety Information
            </span>
          </div>

          <div className="mt-10">
            <Link
              to="/vigorbuy-spreadsheet-beginner-guide"
              className="inline-flex items-center gap-2 text-background-50/60 hover:text-background-50 text-sm font-medium transition-colors cursor-pointer group"
            >
              <span>Read the Complete Beginner Guide</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#categories"
          className="flex flex-col items-center gap-2 text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
        >
          <span className="text-xs font-medium tracking-wider uppercase">Explore Categories</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}